import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
// components
import Pagination from 'components/backoffice/pagination';
import NoResults from './NoResults';

const CustomTable = forwardRef(({
  cols,
  children,
  noResults,
  page,
  totalPages,
  changePage,
  isLoading,
  className = '',
  selected,
  elements
}, ref) => {
  const renderBody = () => {
    if (isLoading) {
      return (
        <tr>
          <td colSpan={cols.length} className="text-center p-5">
            <Spinner animation="border" role="status" />
          </td>
        </tr>
      );
    } else if (noResults) {
      return <NoResults colCount={cols?.length} />;
    } else {
      return children;
    }
  };

  return (
    <>
      <table className={`w-100 table-backoffice ${className}`} ref={ref}>
        <thead className="bg-dark ">
          <tr>
            {cols.map((col) => (
              <th className="text-light" key={col}>
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody id="items-container">{renderBody()}</tbody>
      </table>
      {page && (
        <Pagination
          changePage={changePage}
          page={page}
          totalPages={totalPages}
          selected={selected}
          elements={elements}
        />
      )}
    </>
  );
});

CustomTable.propTypes = {
  children: PropTypes.any,
  cols: PropTypes.array.isRequired,
  noResults: PropTypes.bool,
  page: PropTypes.number,
  totalPages: PropTypes.number,
  changePage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  handleSearch: PropTypes.func,
  className: PropTypes.string,
  selected: PropTypes.number,
  elements: PropTypes.number,
};

export default CustomTable;
